import Centered from "./Centered";

/**
 * Screener phase — renders the campaign's optional pre-survey screener
 * questions and submits to the parent's `onSubmit` once every question
 * has a selected option.
 */
export default function ScreenScreener({
  screenerQuestions, screenerAnswers, setScreenerAnswers,
  tr, onSubmit,
}) {
  return (
    <Centered>
      <div className="bg-white border border-[var(--rl-border)] p-8 max-w-xl w-full" data-testid="screener-screen">
        <div className="text-[10px] uppercase tracking-[0.3em] font-bold text-[var(--rl-text-secondary)]">{tr("screener_title")}</div>
        <h1 className="font-display font-black text-2xl mt-3">{tr("screener_body")}</h1>
        <div className="mt-6 space-y-6">
          {screenerQuestions.map((q, qi) => (
            <div key={`sq-${qi}`} data-testid={`screener-q-${qi}`}>
              <div className="font-semibold text-base">{q.question_text}</div>
              <div className="mt-3 grid gap-2">
                {q.options.map((opt, oi) => {
                  const selected = screenerAnswers[qi] === oi;
                  return (
                    <button
                      key={`sq-${qi}-o-${oi}`}
                      onClick={() => setScreenerAnswers((a) => ({ ...a, [qi]: oi }))}
                      className={`text-left px-4 py-3 border transition-colors ${selected ? "bg-[var(--rl-text)] text-white border-[var(--rl-text)]" : "bg-white border-[var(--rl-border)] hover:border-[var(--rl-text)]"}`}
                      data-testid={`screener-q-${qi}-opt-${oi}`}
                    >
                      {opt.text}
                    </button>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
        <button
          onClick={onSubmit}
          disabled={Object.keys(screenerAnswers).length !== screenerQuestions.length}
          className="mt-8 w-full bg-[var(--rl-text)] text-white py-3 font-semibold hover:bg-[var(--rl-brand)] transition-colors disabled:opacity-40"
          data-testid="screener-submit-btn"
        >
          {tr("screener_submit")}
        </button>
      </div>
    </Centered>
  );
}
